import * as React from "react";
import LogoutIcon from '@mui/icons-material/Logout';
import VBLogo from '../VG-White-NoTag.png'
import { Box, AppBar, Toolbar, Typography, Button } from '@mui/material';
import StatesFilter from './StatesFilter'; 
import DataFilter from './DataFilter';
import { useNavigate } from 'react-router-dom';

export default function Header({ selectedState, onStateChange, selectedData, onDataChange}) {
  const navigate = useNavigate();

  const handleLogout = () => {
    // console.log('Hey, you are not logged in.');
  };

  const [clickCount, setClickCount] = React.useState(0);
  const [elementList, setElementList] = React.useState([]);

  const handleTitleClick = () => {
    setClickCount(clickCount + 1);
    if (clickCount + 1 === 3) {
      const newElement = 'New Element'; 
      setElementList([...elementList, newElement]);
    }
  };


  return (
    <AppBar position="static" elevation={2} sx={{height: '88px'}}>
      <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>
      
      
      <Box sx={{ display: 'flex',  marginTop: '21px', marginLeft: '10px' }}>
        
        <StatesFilter selectedState={selectedState} onStateChange={onStateChange} includeVermont={clickCount >= 3} />
        <DataFilter selectedData={selectedData} onDataChange={onDataChange}  />

      </Box>

      <Box sx={{ display: 'flex', marginTop: '21px', marginLeft: '10px' }}>
        
        <Typography variant="h5" component="div" sx={{ color: 'white', marginLeft:'20px', marginTop: '5px', marginRight: '10px'}}
          onClick={handleTitleClick}>
          Broadband Funding Optimization Tool
        </Typography>

      </Box>


      <Box sx={{ display: 'flex', alignItems: 'center', marginRight:'10px', marginTop: '15px' }}>
      <Typography variant="h6" component="div" sx={{ color: 'white', marginLeft:'50px', marginTop: '0px', marginRight: '10px'}}>
          Powered by
        </Typography>
          <div style={{marginRight: '20px', marginBottom: '10px', marginTop: '0px', marginLeft: '20px'}}>
              <a href="https://vernonburggroup.com" target="_blank" rel="noopener noreferrer">
                  <img src={VBLogo} alt="Vernonburg Group" height={40} style={{marginRight: '20px'}}/>
              </a>
          </div>
          {/*<Button sx={{color: 'white'}} onClick={handleLogout} color="inherit">*/}
          {/*    Logout*/}
          {/*</Button>*/}
          {/*<Button onClick={handleLogout}>*/}
          {/*<LogoutIcon style={{ color: 'white' }} />*/}
          {/*</Button>*/}
      </Box>
      </Toolbar>
    </AppBar>
  );
}


